import Axios from "axios";
import config from "../app.config";

export var companyService;
export default companyService = {
    getCompanyList,
    getCompany,
    updateCompany,
    createNewCompany,
    deleteCompany,
    getCompanyAdmin,
    updateCompanyAdmin,
    createCompanyAdmin,
    getCompanyAdminList,
    deleteCompanyAdmin,
    fetchUsageReport,
}

async function getCompanyList(payload){
    return await Axios.get(`${config.LOCAL_API_URL}/company`,{params: payload})
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error);
    })
}
async function getCompany(id){
    return await Axios.get(`${config.LOCAL_API_URL}/company/${id}`)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}
async function updateCompany(data){
    return await Axios.put(`${config.LOCAL_API_URL}/company/${data.id}`, data)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}
async function deleteCompany(id){
    return await Axios.delete(`${config.LOCAL_API_URL}/company/${id}`)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}
async function createNewCompany(params){
    return await Axios.post(`${config.LOCAL_API_URL}/company`, params)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}
async function getCompanyAdminList(companyId){
    return await Axios.get(`${config.LOCAL_API_URL}/company/${companyId}/admin`)
        .then(response => {
            if(response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error =>{
            return Promise.reject(error.response.data);
        })
}
async function getCompanyAdmin(companyId, userId){
    return await Axios.get(`${config.LOCAL_API_URL}/company/${companyId}/admin/${userId}`)
        .then(response => {
            if(response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error =>{
            return Promise.reject(error.response.data);
        })
}
async function updateCompanyAdmin(companyId, userId, data){
    return await Axios.put(`${config.LOCAL_API_URL}/company/${companyId}/admin/${userId}`, data)
        .then(response => {
            if(response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error =>{
            return Promise.reject(error.response.data);
        })
}
async function createCompanyAdmin(companyId, data){
    return await Axios.post(`${config.LOCAL_API_URL}/company/${companyId}/admin`, data)
        .then(response => {
            if(response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error =>{
            return Promise.reject(error.response.data);
        })
}
async function deleteCompanyAdmin(companyId, userId){
    return await Axios.delete(`${config.LOCAL_API_URL}/company/${companyId}/admin/${userId}`)
        .then(response => {
            if(response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error =>{
            return Promise.reject(error.response.data);
        })
}
async function fetchUsageReport(payload){
    return await Axios.get(`${config.LOCAL_API_URL}/usage`,{params: payload})
        .then(response => {
            if(response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error =>{
            return Promise.reject(error);
        })
}
